<template>
<div>
    <h1 class="pt-2 text-sm"> {{$t('form.paiement.formulaire_de_paiement')}} </h1>
    <div class="p-6 my-4 bg-white border border-gray-200 shadow my-rounded">
        <div v-if="!selected">
            <div class="pb-3 mb-3 text-2xl font-bold border-b border-gray-200"> {{$t('form.paiement.montant_a_payer')}} : {{amount}} € </div>
            <template v-if="errors && errors.length > 0">
                <h6 class="text-red-600">Erreurs</h6>
                <template v-for="(error, index) in errors">
                    <div class="text-red-600" :key="'error-' + index">
                        <small> {{error.message}} </small>
                    </div>
                </template>
                <hr class="my-3">
            </template>
            <template v-if="amountData && (amountData.montant_transport > 0 || amountData.montant_acompte_sta > 0 || amountData.montant_commande_piece > 0)">
                <div class="p-6 mt-5 mb-6 border bg-gray-50 rounded-xl">
                    <div class="text-lg font-bold">{{$t('form.paiement.detail_du_paiement')}}</div>
                    <template v-if="amountData.montant_acompte_sta > 0">
                        <div class="mt-1 text-sm font-light">{{$t('form.paiement.acompte')}}: {{amountData.montant_acompte_sta}} €</div>
                    </template>
                    <template v-if="amountData.montant_transport > 0">
                        <div class="mt-1 text-sm font-light">{{$t('form.paiement.transport')}}: {{amountData.montant_transport}} €</div>
                    </template>
                    <template v-if="amountData.montant_commande_piece > 0">
                        <div class="mt-1 text-sm font-light">{{$t('form.paiement.commande_des_pieces')}}: {{amountData.montant_commande_piece}} €</div>
                    </template>
                    <template v-if="amountData.emballage > 0">
                        <div class="mt-1 text-sm font-light">{{$t('form.paiement.emballage')}}: {{amountData.emballage}} €</div>
                    </template>
                    <div class="mt-1 text-sm underline font-base">{{$t('form.paiement.total')}}: {{amountData.montant_total}} €</div>
                </div>
            </template>
            <div class="flex flex-wrap">
                <sav-input class="w-full mb-3" :label="$t('form.paiement.nom_sur_la_carte')" type="text" v-model="name" />
                <sav-input class="w-full mb-3" :label="$t('form.paiement.numero_de_carte')" type="text" v-model="number" />
                <div class="grid w-full grid-cols-2 gap-3 mb-3">
                    <sav-input :label="$t('form.paiement.mois')" type="select" v-model="month" :options="{ label: 'value', values: [ {value: 1}, {value: 2}, {value: 3}, {value: 4}, {value: 5}, {value: 6}, {value: 7}, {value: 8}, {value: 9}, {value: 10}, {value: 11}, {value: 12}, ] }" />
                    <sav-input :label="$t('form.paiement.annee')" type="select" v-model="year" :options="{ label: 'value', values: cardYears }" />
                </div>
                <sav-input class="w-full" :label="$t('form.paiement.cvv')" type="text" v-model="cvv" />
                <div class="my-5" v-if="loading">
                    <sav-spinner :size="10" />
                </div>
                <button v-if="!loading" :disabled="loading" @click="end" test-id="btn-submit" class="mt-3 text-white bg-green-500 hover:bg-green-600 duration-200 px-3 py-2.5 text-sm font-light border-red-200 rounded">
                    <i class="mr-1 fas fa-check"></i> {{$t('form.paiement.valider')}}
                </button>
            </div>
        </div>
        <div class="font-bold text-green-600" v-if="selected">
            <i class="mr-1 fas fa-check-circle"></i> {{$t('form.paiement.paiement_valide')}}
        </div>
    </div>
</div>
</template>

<script>
import FormCardExtension from '@/extends/FormCardExtension'
import apiService from '@/services/api.service'

export default {
    name: 'paiement',
    extends: FormCardExtension,

    data() {
        return {
            amountData: null,
            amount: 0,
            name: '',
            number: '',
            month: '',
            year: '',
            cvv: '',
            cardYears: [],
            errors: []
        }
    },

    methods: {
        async init() {
            this.loading = true

            // Set amount
            let responseAmount = await apiService.post('get_amount', {
                id_case: JSON.parse(this.$formTool.getFormData('set-case')).id_case
            })
            this.amountData = responseAmount.data.posts.post
            this.amount = this.amountData.montant_total
            if (this.amountData.montant_total == this.amountData.montant_already_paid) {
                this.saveAndContinue(this.amountData)
            }

            // Check if data
            if (this.$formTool.getFormData(this.$options.name)) {
                this.selected = JSON.parse(JSON.stringify(this.$formTool.getFormData(this.$options.name)))
                this.nextBlock = this.$formTool.blockData(this.$options.name).next
            }

            this.createCardyearsValues()

            this.loading = false
        },

        async end() {
            if (this.amount != null && this.number != null && this.name != null && this.month != null && this.year != null && this.cvv != null) {
                this.loading = true
                let response = await apiService.post('pay', {
                    montant: this.amount,
                    card_name: this.name,
                    card_number: this.number,
                    card_month: this.month.value,
                    card_year: this.year.value,
                    card_cvv: this.cvv,
                    id_conso: this.$crypto.decrypt(localStorage.getItem('client_id')),
                    id_case: JSON.parse(this.$formTool.getFormData('set-case')).id_case
                })
                this.errors = []
                if (response.data.posts.error) {
                    this.errors.push({
                        message: response.data.posts.error
                    })
                } else {
                    this.saveAndContinue(response.data)
                }
                this.loading = false
            } else {
                this.errors.push({
                    message: 'Remplir tout les champs'
                })
            }
        },

        saveAndContinue(data) {
            this.$formTool.addFormData(this.$options.name, data)
            this.nextBlock = this.$formTool.blockData(this.$options.name).next
            this.selected = JSON.parse(JSON.stringify(data))
            if (this.selected) {
                this.$emit('update', this.$options.name)
            }
        },

        createCardyearsValues() {
            let currentYear = new Date().getFullYear()
            for (let i = 0; i < 9; i++) {
                this.cardYears.push({value: i + currentYear}) 
            }
        }
    },

    mounted() {
        this.init()
    }
}
</script>



// WEBPACK FOOTER //
// src/processes/cards/procedure/Components/PaiementCard.vue